// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plyr{--plyr-color-main:#a6214b}", "",{"version":3,"sources":["webpack://./site/designsystem/patternlab/patterns/blocks/video/video.css"],"names":[],"mappings":"AAAA,MACE,yBACF","sourcesContent":[".plyr {\n  --plyr-color-main: theme('colors.brand.500');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
